import React from 'react';
import { DatePicker, DropdownSelector, CheckBox } from 'hyperdb-utils';
import moment from 'moment';

const SearchForm = ({
  arrival_date, departure_date, nb_adults, nb_young_adults, nb_children, nb_young_children, nb_babies, ignore_conditions,
  onChange, onSubmit, loading,
}) => {
  const nbPeopleOptions = [];
  for (let i = 1; i <= 10; i ++) { nbPeopleOptions.push({ name: i, value: i }); }
  const handleClickConditions = () => {
    onChange('ignore_conditions', { value: !ignore_conditions });
  };
  const arrivalMaxDate = departure_date ?
    moment(departure_date).subtract(1, 'day')
    : undefined;
  const departureMinDate = arrival_date ?
    moment(arrival_date).add(1, 'day')
    : undefined;
  const openFrom = arrival_date && arrivalMaxDate ? (arrival_date < arrivalMaxDate ? arrival_date : arrivalMaxDate) : arrivalMaxDate || arrival_date;
  const openTo = departure_date && departureMinDate ? (departure_date > departureMinDate ? departure_date : departureMinDate) : departureMinDate || departure_date;
  return (
    <fieldset>
      <div className="row">
        <div className="col-md-4">
          <DatePicker
            label="Arrival date"
            name="arrival_date"
            value={ arrival_date }
            onChange={ onChange.bind(null, 'arrival_date') }
            maxValue={ arrivalMaxDate }
            openToDate={ openFrom }
          />
        </div>
        <div className="col-md-4">
          <DatePicker
            label="Departure date"
            name="departure_date"
            value={ departure_date }
            onChange={ onChange.bind(null, 'departure_date') }
            minValue={ departureMinDate }
            openToDate={ openTo }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-2">
          <DropdownSelector
            label="Adults"
            name="nb_adults"
            value={ nb_adults }
            options={ nbPeopleOptions }
            onChange={ onChange.bind(null, 'nb_adults') }
          />
        </div>
        <div className="col-md-2">
          <DropdownSelector
            label="Young adults"
            name="nb_young_adults"
            value={ nb_young_adults }
            options={ nbPeopleOptions }
            onChange={ onChange.bind(null, 'nb_young_adults') }
          />
        </div>
        <div className="col-md-2">
          <DropdownSelector
            label="Children"
            name="nb_children"
            value={ nb_children }
            options={ nbPeopleOptions }
            onChange={ onChange.bind(null, 'nb_children') }
          />
        </div>
        <div className="col-md-2">
          <DropdownSelector
            label="Young children"
            name="nb_young_children"
            value={ nb_young_children }
            options={ nbPeopleOptions }
            onChange={ onChange.bind(null, 'nb_young_children') }
          />
        </div>
        <div className="col-md-2">
          <DropdownSelector
            label="Babies"
            name="nb_babies"
            value={ nb_babies }
            options={ nbPeopleOptions }
            onChange={ onChange.bind(null, 'nb_babies') }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <CheckBox
            label="Ignore conditions"
            name="ignore_conditions"
            checked={ ignore_conditions }
            onChange={ handleClickConditions }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <button type="button" className="btn btn-primary bnt-sm" disabled={ loading } onClick={ onSubmit }>
            Search
          </button>
        </div>
      </div>
    </fieldset>
  );
};

export default SearchForm;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/components/SearchForm.jsx